var $ = require('jquery');
var styleguide = require('./modules/style-guide.js');
var accordions = require('./modules/accordions.js');
var cards = require('./modules/cards.js');
var menu = require('./modules/menu.js');
var sliders = require('./modules/sliders.js');
var svg = require('./modules/svg.js');

// Make sure that you init the styleguide first.
styleguide.init();
accordions.init();
cards.init();
menu.init();
sliders.init();
svg.init();